import moment from "moment"

export default (time) => {
    const momentTime = moment.isMoment(time) ? time : moment(time)

    return momentTime.format('MM/DD/YYYY HH:mm')
}
